'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "milliseconds" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/milliseconds.js
// module id = 422
// module chunks = 1